import React, { useEffect, useState, useRef } from 'react';
import './RegionalManagerSelect.css';

function RegionalManagerSelect({ value, onChange }) {
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    fetch('/api/listaRegionalManagers')
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setError(data.error);
        } else {
          setManagers(data.managers || []);
        }
      })
      .catch(err => setError('Erro ao carregar gerentes'))
      .finally(() => setLoading(false));
  }, []);

  // Fechar ao clicar fora
  useEffect(() => {
    function handleClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = managers.filter(m => {
    const term = search.toLowerCase();
    return (
      m.displayName.toLowerCase().includes(term) ||
      m.email.toLowerCase().includes(term) ||
      (m.officeLocation || '').toLowerCase().includes(term)
    );
  });

  const handleSelect = (manager) => {
    onChange({
      email: manager.email,
      officeLocation: manager.officeLocation,
      displayName: manager.displayName
    });
    setOpen(false);
    setSearch('');
  };

  if (loading) {
    return <p className="select-loading">Carregando gerentes regionais...</p>;
  }

  if (error) {
    return <p className="select-error">❌ {error}</p>;
  }

  return (
    <div className="regional-select-wrapper" ref={wrapperRef}>
      <div
        className="regional-select-trigger"
        onClick={() => setOpen(!open)}
      >
        {value ? (
          <div className="selected-manager">
            <span className="selected-name">{value.displayName}</span>
            <span className="selected-meta">{value.email} • {value.officeLocation}</span>
          </div>
        ) : (
          <span className="select-placeholder">Selecione um gerente regional...</span>
        )}
        <span className={`select-arrow ${open ? 'open' : ''}`}>▼</span>
      </div>

      {open && (
        <div className="regional-select-dropdown">
          <input
            type="text"
            className="dropdown-search"
            placeholder="Buscar por nome, email ou localização..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />

          <div className="dropdown-list">
            {filtered.length === 0 ? (
              <p className="dropdown-empty">Nenhum gerente encontrado.</p>
            ) : (
              filtered.map(m => (
                <div
                  key={m.id}
                  className={`dropdown-item ${value?.email === m.email ? 'selected' : ''}`}
                  onClick={() => handleSelect(m)}
                >
                  <div className="item-name">{m.displayName}</div>
                  <div className="item-meta">
                    <span>📧 {m.email}</span>
                    <span>📍 {m.officeLocation}</span>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="dropdown-footer">
            {filtered.length} de {managers.length} gerentes
          </div>
        </div>
      )}
    </div>
  );
}

export default RegionalManagerSelect;